import { TealiumBaseEvent } from './TealiumBaseEvent';

export class TealiumShareEvent extends TealiumBaseEvent {
  static readonly SHARE_EVENT = 'share';

  link: string;

  constructor(link: string) {
    super(TealiumShareEvent.SHARE_EVENT, TealiumBaseEvent.EVENT_CATEGORY_CONTENT_INTERACTION, TealiumShareEvent.SHARE_EVENT);
    this.link = link;
    this.uTagInfoMap = this.buildUTagProductInfoMap();

    const socialNetwork = this.getSocialNetworkFromLink(link);

    this.setEventLabel(socialNetwork);
    this.setEventValue({ event_attributes_socialnetwork: socialNetwork });
  }

  getAppName(protocol: string): string | undefined {
    const appMap: { [key: string]: string } = {
      'whatsapp:': 'whatsapp',
      'tg:': 'telegram',
      'viber:': 'viber',
      'fb:': 'facebook',
      'twitter:': 'twitter',
      'instagram:': 'instagram',
      'skype:': 'skype',
      'snapchat:': 'snapchat',
      'linkedin:': 'linkedin',
      'spotify:': 'spotify',
      'mailto:': 'mail',
    };
    const serviceName = appMap[protocol];
    return serviceName || `unknown protocol ${protocol}`;
  }

  getSocialNetworkFromLink(link: string): string {
    let linkURL = new URL(window.location.href);
    try {
      linkURL = new URL(link);
    } catch (err) {
      console.error(err);
      console.error('found URL', link);
      if (link.includes('/share/')) {
        //url is like /wishlist/share/whatsapp
        const socialNetwork = link.substring(link.lastIndexOf('/') + 1);
        return socialNetwork;
      }
    }

    if (linkURL.protocol !== 'https:') {
      return this.getAppName(linkURL.protocol);
    }

    if (linkURL.host === 'www.facebook.com' && linkURL.pathname === '/sharer/sharer.php') {
      return 'facebook';
    }

    return link;
  }
}
